import { TSelectedValuesInput, IHierarchicalOption } from "@/Layouts/types/HierarchicalSelector";
function getDisplayValues<TItem>(options: IHierarchicalOption<TItem>[] = []): TSelectedValuesInput[] {
	const res = options.map(({ displayLabel, id }) => ({
		label: displayLabel,
		value: displayLabel,
		extra: id,
	}));

	return res;
}
function getOptions<TItem>(
	options: IHierarchicalOption<TItem>[],
	displayLabel: string,
	mapFunction?: (item: any) => { name: string; id: string }
): TSelectedValuesInput[] {
	if (!displayLabel) {
		return [];
	}

	const selectedOption = options.find((option) => option.displayLabel === displayLabel);
	if (!selectedOption?.items) {
		return [];
	}
	const res = selectedOption.items.map((item) => {
		// Check if item is a nested option or leaf item
		if (item && typeof item === "object" && "displayLabel" in item) {
			const nestedOption = item as IHierarchicalOption<TItem>;
			return {
				label: nestedOption.displayLabel,
				value: nestedOption.displayLabel,
				extra: nestedOption.id,
			};
		} else {
			// It's a leaf item - use mapFunction
			if (!mapFunction) {
				return {
					label: String(item),
					value: String(item),
					extra: String(item),
				};
			}
			const { name, id } = mapFunction(item);
			return {
				label: name,
				value: name,
				extra: id,
			};
		}
	});
	return res;
}

export { getDisplayValues, getOptions };
